import React from 'react';
import SettingsNav from './SettingsNav';

const SettingsShell = ({ title, description, children }) => (
  <div>
    <div className="lg:flex lg:gap-6">
      <aside className="hidden lg:block lg:w-52 lg:shrink-0">
        <div className="sticky top-20">
          <SettingsNav />
        </div>
      </aside>
      <section className="min-w-0 flex-1 space-y-6">
        {(title || description) && (
          <div className="border-b border-gray-200 pb-5">
            {title && (
              <h2 className="text-2xl font-semibold text-gray-900 tracking-tight">
                {title}
              </h2>
            )}
            {description && (
              <p className="text-sm text-gray-500 mt-1 font-medium">
                {description}
              </p>
            )}
          </div>
        )}
        <div className="space-y-4">
          {children}
        </div>
      </section>
    </div>
  </div>
);

export default SettingsShell;
